const NAME_ALIASES: Record<string, string> = {
  'steam iron': 'Express Steam Iron',
  'steam iron express': 'Express Steam Iron',
  'express steam iron': 'Express Steam Iron',
  'dry clean': 'Dry Cleaning',
  'dry cleaning': 'Dry Cleaning',
  'shoe cleaning': 'Shoe Care',
  'shoe care': 'Shoe Care',
  'bag cleaning': 'Bag Care',
  'bag care': 'Bag Care',
};

export const formatServiceName = (value?: string | null) => {
  const raw = String(value || '').trim();
  if (!raw) return '-';
  return NAME_ALIASES[raw.toLowerCase()] || raw;
};

export const getServicePromise = (value?: string | null, deliveryModel?: string | null) => {
  const name = formatServiceName(value);
  if (String(deliveryModel || '').toLowerCase() === 'express' || name === 'Express Steam Iron') {
    return 'Approx. delivery: 40 minutes';
  }
  return 'Approx. delivery: 4 hours';
};
